import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueCookies from "vue-cookies";
import axios from "axios";
import VueAxios from "vue-axios";
import JsonViewer from "vue-json-viewer";
import VueSweetalert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask';
import vXmlTree from "v-xml-tree";
import moment from 'moment';
import VueBarcode from "vue-barcode";
import i18n from "./i18n";
import ECharts from 'vue-echarts' // refers to components/ECharts.vue in webpack
import { COOKIE_DEVTIMEOUT } from "./services/config";
import html2pdf from 'html2pdf.js';
// import JSZip from "jszip";
// import { VueReCaptcha } from 'vue-recaptcha-v3';

// não mostra as notificações...
// import notificationMixin from './mixins/notificationMixin';
// Vue.mixin(notificationMixin);

import API from './services/apiservices';

import store from "./stores/index";

import TabMeses from "./components/TabMeses";
import ButtonMeses from "./components/ButtonMeses";

// Import Bootstrap an BootstrapVue CSS files (order is important)

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "sweetalert2/dist/sweetalert2.min.css";

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue, {
  BButton: { size: "sm" },
  BDropdown: { size: "sm" },
  BInputGroup: { size: "sm" },
  BTable: { size: "sm" },
  BFormGroup: { size: "sm" },
  BFormInput: { size: "sm" },
  BFormSelect: { size: "sm" },
  BFormTags: { size: "sm" },
  BFormFile: { size: "sm" },
  BFormRating: { size: "sm" },
  BFormDatepicker: { size: "sm" },
  BFormCheckboxGroup: { size: "sm" },
  BPagination: { size: "sm" },
});

Vue.use(IconsPlugin);
Vue.use(VueCookies);
Vue.use(VueAxios, axios);
Vue.use(JsonViewer);
Vue.use(VueSweetalert2);
Vue.use(VueTheMask);

Vue.component("v-xml-tree", vXmlTree);
Vue.component("TabMeses", TabMeses);
Vue.component("ButtonMeses", ButtonMeses);
Vue.component("barcode", VueBarcode);
Vue.component('v-chart', ECharts)
//Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY });

Vue.config.productionTip = false;
Vue.prototype.$isLogged = Vue.$cookies.get("token") && Vue.$cookies.get("token") !== "" ? true : false;
Vue.prototype.$userLogged = Vue.$cookies.get("login") || "";
moment.locale('pt');
Vue.prototype.$moment = moment;
Vue.prototype.$api = API;
Vue.prototype.$html2pdf = html2pdf;

// pipes - inicio =====>
Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
});
Vue.filter("proper", function(value) {
  if (!value) return "";
  value = value.toString();
  return value
    .split(" ")
    .map((a) => a.substr(0, 1).toUpperCase() + a.substr(1).toLowerCase())
    .join(" ");
});
Vue.filter("semacentos", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
});
Vue.filter("datetime", function(value) {
  if (!value) return "";
  return (
    new Date(value).toLocaleDateString() +
    " " +
    new Date(value).toLocaleTimeString()
  );
});
Vue.filter("charcode", function(value) {
  if (!value) return "";
  return String.fromCharCode(parseInt(value) + 64);
});
Vue.filter("bracked", function(value) {
  if (!value) return "";
  return "(" + value + ")";
});
Vue.filter("quoted", function(value) {
  if (!value) return "";
  return '"' + value + '"';
});
Vue.filter("dateBR", function(value) {
  if (!value) return "";
  // return value.substr(5, 2) + '/' + value.substr(8, 2) + '/' + value.substr(0, 4) + ' ' + value.substr(11, 10)
  return new Date(value).toLocaleDateString();
});
Vue.filter("dateFormat", function(value, format) {
  if (!value) return "";
  if (!format) format = "DD/MM/YYYY";
  // return value.substr(5, 2) + '/' + value.substr(8, 2) + '/' + value.substr(0, 4) + ' ' + value.substr(11, 10)
  return moment(value).format(format);
  // return new Date(value).toLocaleDateString();
});
Vue.filter("dateBRHora", function(value) {
  if (!value) return "";
  // return value.substr(5, 2) + '/' + value.substr(8, 2) + '/' + value.substr(0, 4) + ' ' + value.substr(11, 10)
  return new Date(value).toLocaleString();
});
Vue.filter("dateDAY", function(value) {
  if (!value) return "";
  // return value.substr(5, 2) + '/' + value.substr(8, 2) + '/' + value.substr(0, 4) + ' ' + value.substr(11, 10)
  return new Date(value).getDate();
});
Vue.filter("week", function(value) {
  if (!value) return "";
  return new Date(value).getDay();
});
Vue.filter("weekname", function(value, week = new Date(value).getDay() || 0) {
  const wd = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
  if (!value) return "";
  return wd[week];
});
Vue.filter("R$", function(value) {
  if (value==undefined) return "";
  return value.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
});
Vue.filter("moeda", function (value) {
  if (value == undefined) return "";
  if (parseFloat(value) == "NaN") return "";
  return parseFloat(value).toLocaleString("pt-br", { style: "currency", currency: "BRL" });
});
Vue.filter("moedacot", function(value, lang) {
  if (value==undefined) return "";
  if (parseFloat(value) == "NaN") return "";

  // console.log('moedacot.lang', lang);

  let code = { lang: lang || "pt", locale: "", style: "currency", currency: "BRL" };
  if (code.lang == "pt") { code.locale = "pt-BR", code.currency = "BRL" };
  if (code.lang == "en") { code.locale = "pt-BR", code.currency = "USD" };
  if (code.lang == "es") { code.locale = "pt-BR", code.currency = "ARS" };
  if (code.lang == "ch") { code.locale = "pt-BR", code.currency = "CNY" };
  if (code.lang == "it") { code.locale = "pt-BR", code.currency = "EUR" };

  // console.log('moedacot.code', code);

  return parseFloat(value).toLocaleString(code.locale, code);
});
Vue.filter("percent", function(value, decimais = 2) {
  if (!value) return "";
  // return value.toLocaleString(undefined, { style: "percent", minimumFractionDigits: decimais || 2 });
  return parseFloat(value).toFixed(decimais) + " %";
});
Vue.filter("decimals", function(value, decimais = 2) {
  if (!value) return "";
  // return value.toLocaleString(undefined, { style: "percent", minimumFractionDigits: decimais || 2 });
  return parseFloat(value).toFixed(decimais);
});
Vue.filter("peso", function(value, decimais = 3) {
  if (!value) return "";
  // return value.toLocaleString(undefined, { style: "percent", minimumFractionDigits: decimais || 2 });
  return parseFloat(value).toFixed(decimais) + " Kg";
});
Vue.filter("string", function(value) {
  if (!value) return "";
  return value.toString();
});
Vue.filter("truncstring", function(value, len = 10) {
  if (!value) return "";
  return value.toString().length > len ? value.toString().substr(0, len) + '...' : value.toString();
});
Vue.filter("cropright", function(value, pos = 0) {
  if (!value || pos == 0) return value;
  return pos <= value.length ? value.slice(0, -pos) : value;
});
Vue.filter("cropleft", function(value, pos = 0) {
  if (!value || pos == 0) return value;
  return pos <= value.length ? value.slice(pos) : value;
});
Vue.filter("jsonPretty", function(value) {
  let json = JSON.stringify(JSON.parse(value), null, 2);
  json = json
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+]?\d+)?)/g,
    function(match) {
      var cls = "number";
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = "key";
        } else {
          cls = "string";
        }
      } else if (/true|false/.test(match)) {
        cls = "boolean";
      } else if (/null/.test(match)) {
        cls = "null";
      }
      return '<span class="' + cls + '">' + match + "</span>";
    }
  );
});
Vue.filter("filename", function(value) {
  if (!value) return "";
  return value.split('.')[0];
});
// pipes - fim <======

// directives - inicio =====>
Vue.directive("copy", {
  bind: (el, binding, vnode) => {
    el.style.cursor = "copy";
    // el.style.textDecorationHover = "underline";
    // el.style.textDecoration = "underline";
    // el.style.textDecoration[hover] = "underline";
    el.title = "Clique para copiar";

    el.classList.add("vcopy");

    el.addEventListener("mouseenter", function( event ) {
      event.target.style.textDecoration = "underline";
    }, false);
    el.addEventListener("mouseleave", function( event ) {
      event.target.style.textDecoration = "inherit";
    }, false);

    el.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      //console.log('directive.copy: "' + el.innerHTML.trim() + '" copied!');
      navigator.clipboard.writeText(el.innerHTML.trim());
      vnode.context.$root.toastinfo("Copiado para área de transferência!");
      setTimeout(() => {
        vnode.context.$emit("v-copy-event", el.innerHTML);
      }, 1000);
    });
  },
  unbind: (el, binding) => {
    el.removeEventListener("click", () => {});
  },
});
Vue.directive("debounce", {
  // não funcionou ...
  bind: (el, binding) => {
    //console.log("debounce:hit");
    if (binding.value !== binding.oldValue)
      el.oninput = setTimeout(() => {
        el.dispatchEvent(new Event("change"));
      }, 1000);
  },
});
Vue.directive("thdrag", {
  bind: (el, binding, vnode) => {
    //console.log("binding.value", binding.value);
    el.draggable = true;
    el.addEventListener("dragstart", (e) => {
      e.target.parentNode.parentNode.setAttribute(
        // o parent é o TH e o parent do TH é o TR
        "dragstart",
        binding.value
      );
    });
    el.addEventListener("dragenter", (e) => {
      if (
        e.target.parentNode.parentNode.getAttribute("dragstart") !=
        binding.value
      ) {
        e.target.classList.add("thdrag-over");
      }
    });
    el.addEventListener("dragleave", (e) => {
      e.target.classList.remove("thdrag-over");
    });
    el.addEventListener("dragover", (e) => {
      e.preventDefault();
      if (
        e.target.parentNode.parentNode.getAttribute("dragstart") ==
        binding.value
      ) {
        e.target.classList.remove("thdrag-over");
      }
    });
    el.addEventListener("drop", (e) => {
      if (
        e.target.parentNode.parentNode.getAttribute("dragstart") !=
        binding.value
      ) {
        const move = [
          e.target.parentNode.parentNode.getAttribute("dragstart"),
          binding.value,
        ];

        //console.log("move column", move[0], "to", move[1]);

        el.dispatchEvent(
          new CustomEvent("move", {
            bubbles: true,
            detail: move,
          })
        );

        // vnode.context.$root.$emit("move", { event: e, columns: move });
      }
      e.target.classList.remove("thdrag-over");
    });
    /* el.addEventListener("move", (e) => {
      //console.log("move do main");
    }); */
  },
  unbind: (el) => {
    el.removeEventListener("dragstart", () => {});
    el.removeEventListener("dragenter", () => {});
    el.removeEventListener("dragover", () => {});
    el.removeEventListener("dragleave", () => {});
  },
});
Vue.directive("tagpaste", {
  bind: (el, binding) => {
    console.log("tagpaste.el:", el.innerHTML);
    console.log("tagpaste.binding:", binding.value);

    function interceptarColagem(event) {
      // Verificar se a combinação Ctrl+V foi pressionada
      if (event.ctrlKey && event.keyCode === 86) {
        // Prevenir o comportamento padrão da tecla
        event.preventDefault();

        // Obter o conteúdo colado da área de transferência
        const clipboardData = event.clipboardData || window.clipboardData;
        const textoColado = clipboardData.getData('text');
        // Dividir o texto colado em valores separados por vírgulas
      const valores = textoColado.split(',');

        // limpar o valor do componente e adicionar os novos
        binding.value("");
        valores.map(v => {

        })

        // Chamar a função fornecida na diretiva com o texto colado
      }
    }
// Adicionar um ouvinte de evento ao elemento
    el.addEventListener('keydown', interceptarColagem);
  },
  unbind(el) {
    // Remover o ouvinte de evento ao desvincular a diretiva
    el.removeEventListener('keydown', interceptarColagem);
  }
});
Vue.directive('tagInput', {
  bind(el, binding, vnode) {
    el.addEventListener('paste', (event) => {

      event.preventDefault();
      const text = event.clipboardData.getData('text/plain');
      let separator = ',';
      if (text.includes(',')) {
        separator = ','
      } else {
        if (text.includes(';')) {
          separator = ';'
        } else {

          if (text.includes('\n')) {
            separator = '\n'
          }
        }
      }
      const tags = [...vnode.child.value, ...text.split(separator).map(tag => tag.trim())];

      vnode.child.$emit('input', tags);
    });
    el.addEventListener('keydown', (event) => {
      if (event.key === 'Backspace' && vnode.child.value !== "" && vnode.child.$refs.input.value == "") {
        // Remove a última tag
        const tags = vnode.child.value.slice(0, -1);
        vnode.child.$emit('input', tags);
      }
    });
  }
});
Vue.directive("truncstring", {
  bind: (el, binding) => {
    const len = isNaN(Number(binding.value)) ? 10 : binding.value;
    const value = el.innerHTML;
    el.innerHTML = value.toString().length > len ? value.toString().substr(0, len) + '...' : value.toString();
    // não funcionou adicionar o v-b-tooltip.hover em tempo de execução assim ...
    //if (value.length > len) {
    //  Vue.nextTick(function () {
    //    el.setAttribute('v-b-tooltip.hover', '');
    //    el.setAttribute('title', value.toString());
    //    // el.title = value.toString();
    //  });
    //}
  }
});

// Vue directive
Vue.directive('sortableTags', {
  bind(el, binding, vnode) {
    let tags = binding.value;

    el.addEventListener('dragstart', (event) => {
      event.dataTransfer.setData('text/plain', event.target.innerText);
      event.target.classList.add('dragging');
    });

    el.addEventListener('dragover', (event) => {
      event.preventDefault();
    });

    el.addEventListener('drop', (event) => {
      event.preventDefault();
      const draggedText = event.dataTransfer.getData('text/plain');
      const draggedIndex = tags.indexOf(draggedText);
      const dropIndex = Array.from(el.children).indexOf(event.target);

      if (draggedIndex !== -1) {
        tags.splice(draggedIndex, 1);
        tags.splice(dropIndex, 0, draggedText);

        // vnode.context.$emit('update:model', tags);
        vnode.child.$emit('input', tags);
      }

      event.target.classList.remove('dragging');
    });

    el.addEventListener('dragend', () => {
      const draggingElement = el.querySelector('.dragging');
      if (draggingElement) {
        draggingElement.classList.remove('dragging');
      }
    });
  }
});

Vue.directive("select-all", {
  bind: (el) => {
    el.addEventListener('focus', () => { el.select(); });
  },
});
// directives - fim <=====

function setLocale(to, from, next) {
 console.log('setLocale: ', lang);
 if (to && from) {
    const hasLang = to.params && to.params.lang;
    const hadLang = from.params && from.params.lang;

    // If the language hasn't changed since last route we're done
    if (
      hasLang &&
      hadLang &&
      from.params.lang.toLowerCase() === to.params.lang.toLowerCase()
    ) {
      next();
    }

    // Get the save language if it exists
    // let lang = this.$cookies.get('language') ? localStorage.lang.toLowerCase() : 'pt';
    // let lang = document.cookies.get('language') ? localStorage.lang.toLowerCase() : 'pt';
    const navLang = navigator.browserLanguage || navigator.language;
    let lang = "en";

    if (navLang == "pt-BR") lang = "pt";
    if (navLang == "es-ES") lang = "es";
    if (navLang == "zh-CN") lang = "ch";

    // Se não for nenhuma linguagem válida força Inglês
    // if (!['en', 'pt', 'es', 'ch'].includes(lang)) {
    //   lang = 'en'
    // }

    // Overwrite the language with the route if there is one
    if (hasLang) {
      lang = to.params.lang.toLowerCase();
    }

    // Set the website language based on the URL
    i18n.locale = lang;
    localStorage.lang = lang;
    moment.locale('');
    moment.locale(lang);
   //Vue.prototype.$moment().locale(lang);


    // Redirect to a url with the language
    if (!hasLang) {
      return next(`/${lang}${to.fullPath}`);
    }
    return next();
  }
}

function gerarPDF(el, filename = 'documento.pdf', options = {}) {
  html2pdf().from(el).set(options).save(filename);
}

new Vue({
  router,
  store,
  i18n,
  // JSZip,

  beforeMount() {
    // console.log('main.beforeMount');
    // uex] unknown action type: actProfilerGet
    // this.$store.dispatch('actProfilerGet');
  },
  created() {
    // console.log('main.created');
  },

  sessionid: null,
  neverexpires: false,
  methods: {
    navigate(route) {
      if (typeof (route) == "string") route = { path: route };

      if (route.path) {
        if (router.path !== route.path)
          router.push(route);
      }
      if (route.name) {
        if (router !== route.name)
          router.push(route);
      }
    },
    goto(refName) {
      var element = this.$els[refName];
      element.scrollIntoView({ behavior: "smooth" });
    },
    newid() {
      return `_${Math.random(32).toString(32).split(".")[1]}`;
    },
    newdate() {

      // console.log('i18n.locale:', i18n.locale);

      let dt = new Date();

      if (i18n.locale == "pt") dt = new Date(dt.setHours(dt.getHours() - 3));
      if (i18n.locale == "es") dt = new Date(dt.setHours(dt.getHours() - 1));
      if (i18n.locale == "zh") dt = new Date(dt.setHours(dt.getHours() + 12));

      return dt;
    },
    newdatestring() {
      var dataFormatada = new Date().toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });

      dataFormatada = dataFormatada.replace(/\//g, ''); // Remove as barras "/"
      dataFormatada = dataFormatada.replace(/:/g, ''); // Remove os dois pontos ":"
      dataFormatada = dataFormatada.replace(/\s/g, '_'); // Substitui espaços em branco por "_"
      dataFormatada = dataFormatada.replace(/,/g, ''); // Substitui espaços em branco por "_"

      return dataFormatada;
    },
    moedacot(value, lang) {
      if (value==undefined) return "";
      if (parseFloat(value) == "NaN") return "";

      // console.log('moedacot.lang', lang);

      let code = { lang: lang || "pt", locale: "", style: "currency", currency: "BRL" };
      if (code.lang == "pt") { code.locale = "pt-BR", code.currency = "BRL" };
      if (code.lang == "en") { code.locale = "pt-BR", code.currency = "USD" };
      if (code.lang == "es") { code.locale = "pt-BR", code.currency = "ARS" };
      if (code.lang == "ch") { code.locale = "pt-BR", code.currency = "CNY" };
      if (code.lang == "it") { code.locale = "pt-BR", code.currency = "EUR" };

      // console.log('moedacot.code', code);

      return parseFloat(value).toLocaleString(code.locale, code);
    },    
    json2csv(obj, fld = null, sep = ";", quoted = "", whead = true) {
      const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here
      let header = Object.keys(obj[0]);
      if (Array.isArray(fld) && fld.length > 0) {
        header = fld;
      }
      let csv = [
        ...obj.map(
          (row) =>
            header
              .map(
                (fieldName) =>
                  quoted +
                  JSON.stringify(row[fieldName], replacer).replaceAll('"', "") +
                  quoted
              )
              .join(sep) + sep
        ),
      ].join("\r\n");

      if (whead) csv = header.join(sep) + sep + "\r\n" + csv;

      // console.log("json2csv.obj:", obj);
      // console.log("json2csv.fld:", fld);
      // console.log("json2csv.sep:", sep);
      // console.log("json2csv.quoted:", quoted);
      // console.log("json2csv.whead:", whead);
      // console.log("json2csv.csv:", csv.substring(0, 100));

      return csv;
    },

    downloadPath(filepath, fileName) {
      fetch(filepath)
        .then(response => {
          if (!response.ok) {
            throw new Error('Erro ao fazer o download do arquivo.');
          }
          return response.blob();
        })
        .then(blob => {
          var link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", fileName);
          link.setAttribute('target', '_blank');
          link.style.display = "none";
          document.body.appendChild(link); // Required for FF

          link.click(); // This will download the data file named "my_data.csv".

          document.body.removeChild(link);
        })
        .catch(error => {
          //console.log('catch:', error);
          this.toastdanger('Erro ao fazer o download do arquivo.');
        });
    },

    downloadString(strContent, fileName) {
      if (!fileName)
        fileName =
          Math.random()
            .toString(36)
            .split(".")[1] + ".dat";
      strContent.replace(/\\n/g, '\n');
      var encodedUri = encodeURIComponent(strContent);
      var link = document.createElement("a");
      link.setAttribute("href", "data:text/plain;charset=utf-8," + encodedUri);
      link.setAttribute("download", fileName);
      link.style.display = "none";
      document.body.appendChild(link); // Required for FF

      link.click(); // This will download the data file named "my_data.csv".

      document.body.removeChild(link);
    },
    downloadBlob(blob, nomeArquivo) {
      const url = URL.createObjectURL(blob);
      //const url = blob;
      const link = document.createElement('a');
      link.href = url;
      link.download = nomeArquivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // libera memória
    },

    toast(message, config) {
      const h = this.$createElement;
      const title = h("div", [
        h("b-icon-" + config.icon || "hdd-network", {
          style: "width: 16px; height: 16px",
        }),
        h("span", {
          style: "font-weight: bold; margin-left: 5px;",
          domProps: { innerHTML: config.title || "K1 - Soluções" },
        }),
      ]);

      if (!config) {
        config = {
          title: [title],
          autoHideDelay: 5000,
          appendToast: true,
          toaster: 'b-toaster-top-center',
          solid: true,
        };
      }

      if (typeof config == "object") {
        config.title = [title];
        config.autoHideDelay = config.autoHideDelay || 5000;
        config.appendToast = config.appendToast || true;
        config.solid = config.solid || true;
        config.toaster = 'b-toaster-top-center';
      }

      this.$bvToast.toast(message, config);
    },

    toastsuccess(message) {
      this.toast(message, { variant: "success", icon: "hand-thumbs-up" });
    },
    toastdanger(message) {
      this.toast(message, { variant: "danger", icon: "bug" });
    },
    toastinfo(message) {
      this.toast(message, { variant: "info", icon: "info-square" });
    },
    toastwarning(message) {
      this.toast(message, { variant: "warning", icon: "exclamation-square" });
    },
    toastprimary(message) {
      this.toast(message, { variant: "primary", icon: "exclamation-triangle" });
    },
    toastsecondary(message) {
      this.toast(message, { variant: "secondary", icon: "exclamation-octagon" });
    },
    showmessage(msg, title) {
      const h = this.$createElement;
      // const ok = h("span", { domProps: { innerHTML: "&#x2713;" } });
      // const cancel = h("span", { domProps: { innerHTML: "&#x2717;" } });
      const quest = h("div", [
        h("b-icon-question-square", { style: "margin-right: 10px;" }),
        h("span", { domProps: { innerHTML: `${title || "Atenção"}` } }),
      ]);
      const ok = h("b-icon-check", { style: "width: 42px; height: 25px" });
      const cancel = h("b-icon-x", { style: "width: 42px; height: 25px" });

      return this.$bvModal.msgBoxConfirm(msg, {
        title: quest,
        size: "md",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: ok,
        cancelVariant: "danger",
        cancelTitle: cancel,
        footerClass: "p-2",
        hideHeaderClose: false,
      });
      // chamar assim:
      // this.$root.showmessage('Confirme a ação solicitada.', 'Seu título').then(choice => console.log('Voce escolheu:', choice))
    },
    dateBR(data) {
      data = new Date(data);
      var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      };

      return new Intl.DateTimeFormat('pt-BR', options).format(data);
    },
    strToBin(str) {
      return str.split('').map(char =>
        char.charCodeAt(0).toString(2).padStart(8, '0')
      ).join(' ');
    },
    // Mascara do CPF
    Cpf(v){
	    //console.log(v)
		  //Remove tudo o que não é dígito
		  v=v.replace(/\D/g,"")

			 //Coloca um ponto entre o terceiro e o quarto dígitos
			 v=v.replace(/(\d{3})(\d)/,"$1.$2")

			 //Coloca um ponto entre o terceiro e o quarto dígitos
			 //de novo (para o segundo bloco de números)
			 v=v.replace(/(\d{3})(\d)/,"$1.$2")

			 //Coloca um hífen entre o terceiro e o quarto dígitos
			 v=v.replace(/(\d{3})(\d{1,2})$/,"$1-$2")

		 v=v.substring(0,13)
	 return v
	},

	// Mascara do CNPJ
	 Cnpj(v){

		//Remove tudo o que não é dígito
		v=v.replace(/\D/g,"")
				//Coloca ponto entre o segundo e o terceiro dígitos
				v=v.replace(/^(\d{2})(\d)/,"$1.$2")

				//Coloca ponto entre o quinto e o sexto dígitos
				v=v.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")

				//Coloca uma barra entre o oitavo e o nono dígitos
				v=v.replace(/\.(\d{3})(\d)/,".$1/$2")

				//Coloca um hífen depois do bloco de quatro dígitos
				v=v.replace(/(\d{4})(\d)/,"$1-$2")

				v=v.substring(0,17)
		return v
		},
	Celular(v){
		//console.log(v)
		//Remove tudo o que não é dígito
		v=v.replace(/\D/g,"")

			 //Coloca dois parênteses no início
			 v=v.replace(/(\d{2})(\d)/,"($1) $2")

		//Deixa 5 primeiros digitos e depois colo um traço
		v = v.replace(/(\d{5})(\d)/, "$1-$2")
		 v=v.substring(0,14)
	 return v
			},

	Fixo(v){
		//console.log(v)
		//Remove tudo o que não é dígito
		v=v.replace(/\D/g,"")

						//Coloca dois parênteses no início
				v=v.replace(/(\d{2})(\d)/,"($1) $2")

				//Deixa 4 primeiros digitos e depois colo um traço
				v=v.replace(/(\d{4})(\d)/,"$1-$2")
			v=v.substring(0,13)
		return v
		},

		DataNascimento(v){
			//console.log(v)
			//Remove tudo o que não é dígito
			v=v.replace(/\D/g,"")

							//Coloca dois parênteses no início
					v=v.replace(/(\d{2})(\d)/,"$1/$2")

						//Coloca dois parênteses no início
			v = v.replace(/(\d{2})(\d)/, "$1/$2")

				v=v.substring(0,9)
			return v
		},

		Cep(v){
			//console.log(v)
			//Remove tudo o que não é dígito
			v=v.replace(/\D/g,"")

			//Coloca dois parênteses no início
			v = v.replace(/(\d{5})(\d)/, "$1-$2")

				v=v.substring(0,8)
			return v
    },

    encontrarChavePrimaria(array) {
      const todasAsChaves = Object.keys(array[0]);

      const contagemValores = todasAsChaves.reduce((acc, chave) => {
        acc[chave] = array.reduce((contagem, objeto) => {
          const valor = objeto[chave];
          contagem[valor] = (contagem[valor] || 0) + 1;
          return contagem;
        }, {});
        return acc;
      }, {});

      for (const chave in contagemValores) {
        const valoresUnicos = Object.keys(contagemValores[chave]).filter(valor => contagemValores[chave][valor] === 1);
        if (valoresUnicos.length === 1) {
          return chave;
        }
      }

      return null;
    },

    appNeverExpiresSet(value) {
      this.neverexpires = value;
      
      // console.log('Set neverexpires: ', value);
      
      if (value) {
        // console.log("Ativou o never expires");
        // redefine o temnpo do cookie do token para 1 dia
        const token = Vue.$cookies.get("token");
        Vue.$cookies.set("token", token, COOKIE_DEVTIMEOUT);
      } else {
        // console.log("Desativou o never expires");
      }

    },
    appNeverExpiresGet() {
      return this.neverexpires;
    },    

    base64ToArrayBuffer(base64) {
      const binaryString = atob(base64);
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    },

    isEmptyObject(obj) {
      return !!Object.keys(obj).length;
    }, 
    
    submitFormDataToNewWindow(url, atrib) {
      // Cria um formulário dinâmico
      const form = document.createElement("form");
      form.action = url; // Define a URL de destino
      form.method = "POST"; // Define o método HTTP
      form.target = "_labelary"; // Abre em uma nova aba ou janela

      // Adiciona os campos do FormData ao formulário
      for (const [key, value] of atrib.entries()) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      }

      // Anexa o formulário ao documento e o submete
      document.body.appendChild(form);
      form.submit();

      // Remove o formulário após o envio
      document.body.removeChild(form);
    },

    dataToArray(data) {
      let ret = [];
      if (Array.isArray(data)) {
        ret = data;
      } else {
        if (typeof data == "object") {
          ret = JSON.parse(
            JSON.stringify(this.$route.query.orcamentos)
          );
        } else {
          ret.push(data)
        }
      }

      return ret;
    }
    
  },
  render: (h) => h(App),
}).$mount("#app");
